
import React from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import HizmetlerPage from '../pages/hizmetler/page';
import HakkimizdaPage from '../pages/hakkimizda/page';
import IletisimPage from '../pages/iletisim/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hizmetler',
    element: <HizmetlerPage />,
  },
  {
    path: '/hakkimizda',
    element: <HakkimizdaPage />,
  },
  {
    path: '/iletisim',
    element: <IletisimPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
